module.exports = __webpack_public_path__ + "38d4b5fba7a4955e035b5a3898a8cd5d.woff2";